import BrowserMd5File from 'browser-md5-file';
const browserMd5File = new BrowserMd5File();

export default function fileMD5(file) {
  return new Promise((resolve, reject) => {
    browserMd5File.md5(file, (err, hash) => {
      if (err) {
        reject(err);
      } else {
        resolve(hash);
      }
    });
  });
}
